<div [ngClass]="['blog-links', resourcesCssService.responsiveClass()]">

  <a (click)='goToTeacherNotes()' class="back-to-teacher-notes" *ngIf="showHeader"><i class="fa fa-arrow-left"></i> Teacher Blog Home</a>
  <span class="toc-header" *ngIf="!showHeader">Teacher Blog Articles</span>

  <ng-container *ngFor='let article of items;'>
      <button [ngClass]='{"selected": isCurrentArticle(article.slug)}' (click)='gotoArticle(article)'>{{article.title}}</button>
  </ng-container>
  <div class="pagination-buttons" *ngIf='totalPages > 1'>
    <button (click)='previousPage()' class="previous" [ngClass]=prevClass><i class="fa fa-caret-left"></i> Newer</button>
    <button (click)='nextPage()' class="next" [ngClass]=nextClass>Older <i class="fa fa-caret-right"></i></button>    
  </div>

</div>